import React, { useContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { endSession } from './API/repositories/user';
import { LOGIN_PATH } from './API/constants/auth';
import { AuthContext } from '@/common/contexts/authContext';


const AccessMap = {
	consultant: 'CONSULTANT_COMMON',
};

const AccesValidator = () => {
	const { authUser, checkAccess, setAuthUser } = useContext(AuthContext);

	const { pathname } = useLocation();
	const navigate = useNavigate();

	const handleLogout = async () => {
		await endSession();
		setAuthUser(null);
		navigate(LOGIN_PATH);
	};

	useEffect(() => {
		const isConsultantPath = pathname.split('/')[1] === 'consultant';
		if (!isConsultantPath) {
			return;
		}

		const user = authUser;
		if (!user || !checkAccess(AccessMap['consultant'])) {
			handleLogout();
		}
	}, [pathname]);

	return <></>;
};

export default AccesValidator;
